import * as Yup from 'yup';

export type FormInputs = {
  email: string | null;
};

export const initialValues: FormInputs = {
  email: '',
};

export const createValidationSchema = () =>
  Yup.object().shape({
    email: Yup.string().email('yup.email').nullable().required('yup.required'),
  });

export const validationSchema = createValidationSchema();

export type CodeContactValues = Yup.InferType<typeof validationSchema>;

export const parseValues = (values: CodeContactValues) => {
  return {
    email: values.email || '',
  };
};
